/**
 * Created by Nico on 18.07.2016.
 */
define('services/TitleService',['app', 'modules/module', 'services/EntityCrudService'], function (app, module) {
	'use strict';
	return module.factory('TitleService', ['$injector', TitleService]);
});

function TitleService($injector) {
	crudInstance = $injector.instantiate(CrudService);
	crudInstance.setType('Title');

	angular.extend(this, crudInstance);

	return this;
}
;
